import {
  getAll,
  getPage,
  getDetail,
  deleteObj,
  getMyRecvAll,
  getMyRecvPage,
  noticeUsers,
  noticeUserGroups,
  confirmNotice,
  readNotice,
} from '@/api/noticeserv'

export default {
  state: {
    state_Notice_GetAllResult: null,
    state_Notice_GetPageResult: null,
    state_Notice_GetDetailResult: null,
    state_Notice_DeleteObjResult: null,
    state_Notice_GetMyRecvAllResult: null,
    state_Notice_GetMyRecvPageResult: null,
    state_Notice_NoticeUsersResult: null,
    state_Notice_NoticeUserGroupsResult: null,
    state_Notice_ConfirmNoticeResult: null,
    state_Notice_ReadNoticeResult: null,
  },
  mutations: {
    SET_NOTICE_GETALL_RESULT: (state, rst) => {
      state.state_Notice_GetAllResult = rst;
    },
    SET_NOTICE_GETPAGE_RESULT: (state, rst) => {
      state.state_Notice_GetPageResult = rst;
    },
    SET_NOTICE_GETDETAIL_RESULT: (state, rst) => {
      state.state_Notice_GetDetailResult = rst;
    },
    SET_NOTICE_DELETEOBJ_RESULT: (state, rst) => {
      state.state_Notice_DeleteObjResult = rst;
    },
    SET_NOTICE_GETMYRECVALL_RESULT: (state, rst) => {
      state.state_Notice_GetMyRecvAllResult = rst;
    },
    SET_NOTICE_GETMYRECVPAGE_RESULT: (state, rst) => {
      state.state_Notice_GetMyRecvPageResult = rst;
    },
    SET_NOTICE_NOTICEUSERS_RESULT: (state, rst) => {
      state.state_Notice_NoticeUsersResult = rst;
    },
    SET_NOTICE_NOTICEUSERGROUPS_RESULT: (state, rst) => {
      state.state_Notice_NoticeUserGroupsResult = rst;
    },
    SET_NOTICE_CONFIRMNOTICE_RESULT: (state, rst) => {
      state.state_Notice_ConfirmNoticeResult = rst;
    },
    SET_NOTICE_READNOTICE_RESULT: (state, rst) => {
      state.state_Notice_ReadNoticeResult = rst;
    },
  },
  actions: {
    NoticeServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NOTICE_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NOTICE_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NoticeServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NOTICE_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NOTICE_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NoticeServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NOTICE_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NOTICE_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NoticeServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NOTICE_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NOTICE_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NoticeServ_GetMyRecvAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyRecvAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NOTICE_GETMYRECVALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NOTICE_GETMYRECVALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NoticeServ_GetMyRecvPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyRecvPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NOTICE_GETMYRECVPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NOTICE_GETMYRECVPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NoticeServ_NoticeUsers({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        noticeUsers(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NOTICE_NOTICEUSERS_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NOTICE_NOTICEUSERS_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NoticeServ_NoticeUserGroups({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        noticeUserGroups(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NOTICE_NOTICEUSERGROUPS_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NOTICE_NOTICEUSERGROUPS_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NoticeServ_ConfirmNotice({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        confirmNotice(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NOTICE_CONFIRMNOTICE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NOTICE_CONFIRMNOTICE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    NoticeServ_ReadNotice({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        readNotice(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_NOTICE_READNOTICE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_NOTICE_READNOTICE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_Notice_GetAllResult: state => {
      return state.state_Notice_GetAllResult;
    },
    get_Notice_GetPageResult: state => {
      return state.state_Notice_GetPageResult;
    },
    get_Notice_GetDetailResult: state => {
      return state.state_Notice_GetDetailResult;
    },
    get_Notice_DeleteObjResult: state => {
      return state.state_Notice_DeleteObjResult;
    },
    get_Notice_GetMyRecvAllResult: state => {
      return state.state_Notice_GetMyRecvAllResult;
    },
    get_Notice_GetMyRecvPageResult: state => {
      return state.state_Notice_GetMyRecvPageResult;
    },
    get_Notice_NoticeUsersResult: state => {
      return state.state_Notice_NoticeUsersResult;
    },
    get_Notice_NoticeUserGroupsResult: state => {
      return state.state_Notice_NoticeUserGroupsResult;
    },
    get_Notice_ConfirmNoticeResult: state => {
      return state.state_Notice_ConfirmNoticeResult;
    },
    get_Notice_ReadNoticeResult: state => {
      return state.state_Notice_ReadNoticeResult;
    },
  }
}